import { useState } from 'react';

export function TokenForm({
    onTokenChange,
    error,
}) {
    const [token, setToken] = useState('');
    const handleSubmit = (e) => {
        e.preventDefault();

        onTokenChange(token);
        setToken('');
    };

    return (
        <div className="divide-gray-200 divide-y m-8">
            <form className="bg-white h-[56px] p-4 rounded shadow-md flex" onSubmit={handleSubmit}>
                <input type="text" name="token" placeholder="Token ..." className={'h-full flex-auto ' + (error ? 'border-red-500' : '')} value={token} onChange={(e) => setToken(e.currentTarget.value)} />
            </form>
        </div >
    );
};
